import {get, getMeditations, getOwned} from '../models/Package';

const getPackage = (caller, payload) => {
    return {
        type: "GET_PACKAGE",
        payload: get(caller, payload),
        meta: {id: payload}
    }
};

const getPackages = (caller) => {
    return {
        type: "GET_PACKAGES",
        payload: get(caller)
    }
};

const getUserPackages = (caller) => {
    return {
        type: "GET_USER_PACKAGES",
        payload: getOwned(caller)
    }
};

const getPackageMeditations = (caller, payload) => {
    return {
        type: "GET_PACKAGE_MEDITATIONS",
        payload: getMeditations(caller, payload),
        meta: {id: payload}
    }
};

export {getPackage, getPackages, getUserPackages, getPackageMeditations};


// WEBPACK FOOTER //
// ./src/actions/Package.js